module.exports = __webpack_public_path__ + "static/img/csc_05.19a9736c.png";